module.exports = __webpack_public_path__ + "img/temisan.0e3c1182.svg";